import type { JourneyPlanningFormState } from '../../../../../data/useJourneyPlanning';

export interface JourneyPlanFormModel {
  locations: {
    originQuery: JourneyPlanningFormState['locations']['originQuery'];
    destinationQuery: JourneyPlanningFormState['locations']['destinationQuery'];
    originOptions: JourneyPlanningFormState['locations']['originOptions'];
    destinationOptions: JourneyPlanningFormState['locations']['destinationOptions'];
    onOriginChange: JourneyPlanningFormState['locations']['onOriginChange'];
    onDestinationChange: JourneyPlanningFormState['locations']['onDestinationChange'];
    onOriginSelectOption: JourneyPlanningFormState['locations']['onOriginSelectOption'];
    onDestinationSelectOption: JourneyPlanningFormState['locations']['onDestinationSelectOption'];
    onSwapLocations: JourneyPlanningFormState['locations']['onSwapLocations'];
    onUseCurrentOrigin: JourneyPlanningFormState['locations']['handleUseCurrentOrigin'];
    onUseCurrentDestination: JourneyPlanningFormState['locations']['handleUseCurrentDestination'];
    originIsCurrentLocation: JourneyPlanningFormState['locations']['originIsCurrentLocation'];
    destinationIsCurrentLocation: JourneyPlanningFormState['locations']['destinationIsCurrentLocation'];
  };
  time: {
    mode: JourneyPlanningFormState['time']['mode'];
    date: JourneyPlanningFormState['time']['date'];
    time: JourneyPlanningFormState['time']['time'];
    onModeChange: JourneyPlanningFormState['time']['onModeChange'];
    onDateChange: JourneyPlanningFormState['time']['onDateChange'];
    onTimeChange: JourneyPlanningFormState['time']['onTimeChange'];
  };
  filters: {
    value: JourneyPlanningFormState['filters']['value'];
    onChange: JourneyPlanningFormState['filters']['onChange'];
  };
  submit: {
    run: JourneyPlanningFormState['submit']['submitJourneySearch'];
    handleSubmit: (event: Event) => boolean;
    loading: boolean;
  };
}

export function createJourneyPlanFormModel(
  form: JourneyPlanningFormState,
  options: { loading: boolean },
): JourneyPlanFormModel {
  return {
    locations: {
      originQuery: form.locations.originQuery,
      destinationQuery: form.locations.destinationQuery,
      originOptions: form.locations.originOptions,
      destinationOptions: form.locations.destinationOptions,
      onOriginChange: form.locations.onOriginChange,
      onDestinationChange: form.locations.onDestinationChange,
      onOriginSelectOption: form.locations.onOriginSelectOption,
      onDestinationSelectOption: form.locations.onDestinationSelectOption,
      onSwapLocations: form.locations.onSwapLocations,
      onUseCurrentOrigin: form.locations.handleUseCurrentOrigin,
      onUseCurrentDestination: form.locations.handleUseCurrentDestination,
      originIsCurrentLocation: form.locations.originIsCurrentLocation,
      destinationIsCurrentLocation: form.locations.destinationIsCurrentLocation,
    },
    time: {
      mode: form.time.mode,
      date: form.time.date,
      time: form.time.time,
      onModeChange: form.time.onModeChange,
      onDateChange: form.time.onDateChange,
      onTimeChange: form.time.onTimeChange,
    },
    filters: {
      value: form.filters.value,
      onChange: form.filters.onChange,
    },
    submit: {
      run: form.submit.submitJourneySearch,
      handleSubmit: (event: Event) =>
        form.submit.handleSubmit(event as SubmitEvent),
      loading: options.loading,
    },
  };
}

export function submitJourneyPlanForm(
  form: JourneyPlanFormModel,
  onSuccess?: () => void,
) {
  return (event?: Event) => {
    event?.preventDefault();

    if (form.submit.run()) {
      onSuccess?.();
    }
  };
}
